<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              v-model="form.filters.assunto"
              label="Assunto da Notificação"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sigfoco-date-picker
              :cols="3"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
          ></sigfoco-date-picker>
          <sigfoco-date-picker
            :cols="3"
            v-model="form.filters.dataFinal"
            label="Data Final"
            removeIcon
            outlined
            dense
          ></sigfoco-date-picker>
          <v-col cols="3">
            <v-select
              v-model="form.filters.grupoId"
              :items="form.lists.grupos"
              item-text="nome"
              item-value="id"
              label="Grupo"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarGrupoNotificacoes()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Incluir"
              icon="mdi-plus"
              @click="openDialogManterGrupoNotificacao()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:[`item.assunto`]="{ item }">
          {{ item.assunto}}
        </template>
        <template v-slot:[`item.dataNotificacaoStr`]="{ item }">
          {{ item.dataNotificacaoStr}}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td class="grupos" :colspan="headers.length">
              <v-chip-group active-class="primary--text" column>
                <v-chip
                  class="chip-permissao"
                  v-for="(grupo, i) in item.grupos"
                  :key="i"
                >
                  <v-icon class="grupo" small>mdi-account-multiple</v-icon>
                  {{ grupo.nome }}
                </v-chip>
              </v-chip-group>
            </td>
          </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Visualizar Notificação"
            icon="mdi-eye-outline"
            small
            @click="openDialogVisualizarGrupoNotificacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Reenviar Notificação"
            icon="mdi-plus-circle-outline"
            small
            @click="openDialogManterGrupoNotificacao(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <VisualizarGrupoNotificacaoDialog
      v-if="dialogVisualizarGrupoNoficicacao.visible"
      :visible="dialogVisualizarGrupoNoficicacao.visible"
      :content="dialogVisualizarGrupoNoficicacao.content"
      @onClose="dialogVisualizarGrupoNoficicacao.close()"
    ></VisualizarGrupoNotificacaoDialog>
    <AdicionarGrupoNotificacaoDialog
      :edit="dialogManterGrupoNoficicacao.edit"
      :visible="dialogManterGrupoNoficicacao.visible"
      :content="dialogManterGrupoNoficicacao.content"
      @onClose="dialogManterGrupoNoficicacao.close()"
      @onSave="buscarGrupoNotificacoes()"
    ></AdicionarGrupoNotificacaoDialog>
  </div>
</template>

<script>
import { Dialog } from "~/commons/classes/dialog";
import ManterGrupoNotificacaoService from "@/services/manter-grupo-notificacao.service"
import AdicionarGrupoNotificacaoDialog from "./dialogs/AdicionarGrupoNotificacaoDialog.vue";
import { GrupoNotificacao } from "~/commons/classes/grupo-notificacao";
import VisualizarGrupoNotificacaoDialog from "./dialogs/VisualizarGrupoNotificacaoDialog.vue";
import ManterGrupoService from "@/services/manter-grupo.service"

export default {
  name: "ManterGrupoNotificacaoView",
  mixins: [ManterGrupoNotificacaoService, ManterGrupoService],
  components: {
    AdicionarGrupoNotificacaoDialog,
    VisualizarGrupoNotificacaoDialog
  },
  data: () => ({
    dialogManterGrupoNoficicacao: Dialog.Build(),
    dialogVisualizarGrupoNoficicacao: Dialog.Build(),
    expanded: [],
    form:{
      filters: {
        assunto: null,
        dataInicio: null,
        dataFinal: null,
        grupoId: null,
      },
      lists: {
        grupos: [],
      }
    },
    table: {
      headers: [
        { text: "Assunto da Notificação", align: "center", value: "assunto" },
        { text: "Data da Notificação", align: "center", value: "dataNotificacaoStr" },
        { text: "Grupo", align: "center", value: "data-table-expand" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    buscarGrupoNotificacoes() {
      const isValid = this.validarDatas();
      if (!isValid) return;
      this.$buscarGrupoNotificacoes({ params: this.form.filters }).then(({ data }) => this.table.itens = data.itens)
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.expanded = [];
      this.$nextTick(() => {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFinal = null;
        });

    },
    openDialogManterGrupoNotificacao(grupoNotificacao) {
      grupoNotificacao
        ? this.$visualizarGrupoNotificacao(grupoNotificacao.id).then(({ data }) => this.dialogManterGrupoNoficicacao.open(new GrupoNotificacao(data.item), true))
        : this.dialogManterGrupoNoficicacao.open(GrupoNotificacao.Build());
    },
    openDialogVisualizarGrupoNotificacao(grupoNotificacao) {
      this.$visualizarGrupoNotificacao(grupoNotificacao?.id)
      .then(({ data }) => this.dialogVisualizarGrupoNoficicacao.open(new GrupoNotificacao(data.item)));
    },
    validarDatas() {
        const { dataInicio, dataFinal } = this.form.filters;
        if (dataInicio && dataFinal) {
          if (new Date(dataFinal) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
        }
        return true;
      },
  },
  mounted() {
    this.$buscarGrupos({ params: {situacao: true} }).then(({ data }) => this.form.lists.grupos = data.lista)
  }
}
</script>